import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";

import { VacationRequestsGridComponent } from "./vacation-requests-grid/vacation-requests-grid.component";

const routes: Routes = [
    { path: '', component: VacationRequestsGridComponent },
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class VacationsRequestRoutingModule { }
